import type { HydratedImage } from "../generated/api/types.gen";
import { ImageGridItem } from "./ImageGridItem";

interface ImageSelectorProps {
  images: HydratedImage[];
  selectedImageIndex: number | null;
  isRegenerating: boolean;
  isInitialLoading: boolean;
  onSelectImage?: (index: number) => void;
  onEnterRefinementMode?: (index: number) => void;
}

export function ImageSelector({
  images,
  selectedImageIndex,
  isRegenerating,
  isInitialLoading,
  onSelectImage,
  onEnterRefinementMode,
}: ImageSelectorProps) {
  return (
    <div className="flex-1 min-h-0 flex items-center justify-center">
      <div className="grid grid-cols-2 grid-rows-2 gap-4 h-full aspect-[3/2] max-w-full">
        {[0, 1, 2, 3].map((index) => {
          // Show loading spinner if:
          // 1. We're regenerating (user clicked regenerate), OR
          // 2. We're in initial loading state, OR
          // 3. Images array is empty (waiting for images to arrive)
          const isLoading =
            isRegenerating || isInitialLoading || images.length === 0;
          return (
            <ImageGridItem
              key={index}
              image={images[index]}
              index={index}
              isSelected={selectedImageIndex === index}
              isLoading={isLoading}
              onSelect={() => onSelectImage?.(index)}
              onEnterRefinementMode={onEnterRefinementMode}
            />
          );
        })}
      </div>
    </div>
  );
}
